import { Pedido } from '../pedido/pedido.model';
import { Injectable } from '@angular/core';

@Injectable()
export class PedidoFakeDb
{
    public pedido: Pedido[] = [];
}
